'use client'

import React from 'react'
import LocaleContext from './LocaleContext'
import {defaultLocaleId} from '@local/config/locales.mjs'

export const clientLocale = {current: defaultLocaleId}

export default function ({children, value}) {
	clientLocale.current = value.locale

	return (
		<LocaleContext.Provider value={value}>
			{children}
		</LocaleContext.Provider>
	)
}
